import { render, staticRenderFns } from "./ImprestReceiptAccounting.vue?vue&type=template&id=045427d4&scoped=true"
import script from "./ImprestReceiptAccounting.vue?vue&type=script&lang=js"
export * from "./ImprestReceiptAccounting.vue?vue&type=script&lang=js"
import style0 from "./ImprestReceiptAccounting.vue?vue&type=style&index=0&id=045427d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045427d4",
  null
  
)

export default component.exports